import SystemConfigurationDetail from './SystemConfigurationDetail';

function EmailConfigComponent() {
  return <SystemConfigurationDetail mode="email" />;
}

export default EmailConfigComponent;
